<template>
    <div class="custom-container">
        <el-tabs v-model="activeName">
            <el-tab-pane label="返校记录" name="first">
                <div v-if="type === 'mobile'">
                    <el-form label-width="80px" label-position="left" width="100%">
                        <el-form-item label="班级">
                            {{ form.className }}
                        </el-form-item>

                        <el-form-item label="返校时间">
                            {{ form.date }}
                        </el-form-item>
                        <el-form-item label="返校地点">
                            {{ form.site }}
                        </el-form-item>
                        <el-form label-position="top" width="100%">
                            <el-form-item label="返校主题">
                                {{ form.theme }}
                            </el-form-item>
                            <el-form-item label="返校情况">
                                {{ form.situation }}
                            </el-form-item>
                        </el-form>
                    </el-form>
                </div>

                <div v-else style="height: 500px; overflow: auto;">
                    <el-form :model="form" ref="form" label-width="80px" label-position="left" width="100%"
                             :rules="rules">
                        <el-row>
                            <el-form-item label="班级" prop="classCode">
                                <el-select v-if="recType === 'add'" v-model="form.classCode" placeholder="请选择班级"
                                           style="width: 100%" clearable>
                                    <el-option v-for="(item, index) in comboOption.class" :key="item.comboValue"
                                               :value="item.comboValue"
                                               :label="item.comboName"/>
                                </el-select>
                                <span v-if="recType !== 'add'">{{ form.className }}</span>
                            </el-form-item>
                        </el-row>
                        <el-row>
                            <el-col :span="12">
                                <el-form-item label="返校时间" prop="date">
                                    <el-date-picker placeholder="请选择返校时间"
                                                    v-model="form.date" type="date" value-format="yyyy-MM-dd"
                                                    style="width: 100%" :readonly="userType === 'stu'"/>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="返校地点" prop="site">
                                    <el-input placeholder="请输入返校地点" v-model="form.site" maxlength="100"
                                              :readonly="userType === 'stu'"/>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row>
                            <el-form-item label="返校主题" prop="theme">
                                <el-input type="textarea" :rows="5" maxlength="500"
                                          show-word-limit v-model="form.theme" :readonly="userType === 'stu'"/>
                            </el-form-item>
                        </el-row>
                        <el-row>
                            <el-form-item label="返校情况" prop="situation">
                                <el-input type="textarea" :rows="5" maxlength="500"
                                          show-word-limit v-model="form.situation" :readonly="userType === 'stu'"/>
                            </el-form-item>
                        </el-row>
                    </el-form>
                </div>
                <div v-if="userType !== 'stu'" style="width:100%; text-align:center; margin-bottom:20px;">
                    <el-button type="primary" @click="saveRec">保 存</el-button>
                    <el-button @click="callback">关 闭</el-button>
                </div>
            </el-tab-pane>
            <el-tab-pane label="学生出勤" name="second">
                <div style="height: 500px;overflow: auto">
                    <div v-if="userType === 'stu'">
                        <el-form label-width="80px" label-position="left" width="100%">
                            <el-form-item label="出勤状态">
                                {{ parseAttendance(stuAttendanceInfo) }}
                            </el-form-item>

                            <el-form-item label="情况说明">
                                {{ stuAttendanceInfo.situation }}
                            </el-form-item>
                        </el-form>
                    </div>
                    <div v-else>
                        <div v-if="recType === 'add'"
                             style="width:100%; text-align:center; font-size:18px; font-weight:bold; color:#a7a8ac; margin-top:50px;">
                            首次保存返校记录后可修改学生出勤信息
                        </div>
                        <div v-else>
                            <div class="filter-container">
                                <el-input v-model="queryStuForm.stuCode" placeholder="学号 / 姓名" style="width:250px;"
                                          clearable/>
                                <el-button @click="loadStuAttendance" type="gray" style="margin-left: 10px;"><i
                                    class="el-icon-search"></i>&nbsp;查询
                                </el-button>
                                <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i>&nbsp;重置
                                </el-button>
                                <!--                                <el-button type="success" @click="changeAttendanceState('1')"><i-->
                                <!--                                    class="el-icon-success"></i>&nbsp;出勤-->
                                <!--                                </el-button>-->
                                <!--                                <el-button type="danger" @click="changeAttendanceState('0')"><i-->
                                <!--                                    class="el-icon-error"></i>&nbsp;缺勤-->
                                <!--                                </el-button>-->
                            </div>
                            <el-table :data="tableData" stripe border fit highlight-current-row
                                      header-cell-class-name="tableHeadStyle" height="400px"
                                      ref="mainTable" style="width:100%;" @selection-change="handleSelection">
                                <el-table-column type="index" :index="indexMethod" align="center"/>
                                <!--                                <el-table-column type="selection" width="55"/>-->
                                <el-table-column label="学号" prop="stuCode" align="center" width="150px"/>
                                <el-table-column label="姓名" prop="stuName" align="center" width="150px"/>
                                <!--                                <el-table-column label="出勤状态" prop="attendance" align="center" :formatter="parseAttendance" width="80px"/>-->
                                <!--                                <el-table-column label="情况说明" prop="situation" align="center":formatter="parseSituation"/>-->
                                <el-table-column label="出勤状态" align="center" width="100px">
                                    <template slot-scope="scope">
                                        <el-select v-model="scope.row.attendance"
                                                   @change="changeAttendanceState(scope.row)">
                                            <el-option v-for="item in comboOption.attendance" :key="item.comboValue"
                                                       :label="item.comboName" :value="item.comboValue"/>
                                        </el-select>
                                    </template>
                                </el-table-column>
                                <el-table-column label="情况说明" align="center">
                                    <template slot-scope="scope">
                                        <el-input maxlength="500" @blur="changeSituation(scope.row)"
                                                  v-model="scope.row.situation"/>
                                    </template>
                                </el-table-column>

                                <!--                                <el-table-column label="操作" width="180px" align="center">-->
                                <!--                                    <template slot-scope="scope">-->
                                <!--                                        <el-button type="warning" size="small" @click="modSituation(scope.row)">-->
                                <!--                                            <i class="el-icon-edit"></i>&nbsp;编辑-->
                                <!--                                        </el-button>-->
                                <!--                                    </template>-->
                                <!--                                </el-table-column>-->
                            </el-table>
                        </div>
                    </div>

                </div>
            </el-tab-pane>
            <el-tab-pane label="学生返校照片" name="third">
                <div style="height: 500px;overflow: auto">
                    <div v-if="recType === 'add'"
                         style="width:100%; text-align:center; font-size:18px; font-weight:bold; color:#a7a8ac; margin-top:50px;">
                        首次保存返校记录后可上传照片
                    </div>

                    <div v-else>
                        <el-upload v-if="userType==='stu'" accept=".png,.jpeg,.jpg" action :http-request="uploadPhoto"
                                   :file-list="fileImgList" list-type="picture-card" :class="'hidden-Btn'"
                                   :disabled="true"
                                   :on-preview="handlePictureCardPreview"><i class="el-icon-plus"></i>
                            <template slot="file" slot-scope="{ file }">
                                <div class="el-upload-list__item-thumbnail">
                                    <img width="146px" height="146px" :src="file.url" alt=""/>
                                </div>
                                <span class="el-upload-list__item-actions">
                                    <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                                        <i class="el-icon-zoom-in"></i>
                                    </span>
                                    <span v-if="userType!=='stu'" class="el-upload-list__item-delete"
                                          @click="handleRemove(file)">
                                        <i class="el-icon-delete"></i>
                                    </span>
                                </span>
                            </template>
                        </el-upload>

                        <el-upload v-if="userType!=='stu'" accept=".png,.jpeg,.jpg" action :http-request="uploadPhoto"
                                   :file-list="fileImgList" list-type="picture-card"
                                   :on-preview="handlePictureCardPreview"
                                   :on-remove="handleRemove">
                            <i class="el-icon-plus"></i>
                        </el-upload>

                        <previewer v-if="previewerVisible" ref="previewer" :fileInfo="fileInfo"
                                   :widthPercent="60" :heightNum="650" :topNum="60"
                                   @closePreviewer="previewerVisible = false;">
                        </previewer>
                    </div>
                </div>
            </el-tab-pane>


            <el-dialog title="编辑" :visible.sync="modSituationDialogVisible" top="150px" width="650px"
                       v-if="modSituationDialogVisible"
                       append-to-body>
                <el-form label-width="80px" label-position="left" width="100%">
                    <el-form-item label="学号">
                        {{ modSituationForm.stuCode }}
                    </el-form-item>
                    <el-form-item label="姓名">
                        {{ modSituationForm.stuName }}
                    </el-form-item>
                    <el-form-item label="出勤状态">
                        <el-select v-model="modSituationForm.attendance" placeholder="请选择出勤状态"
                                   style="width: 100%" clearable>
                            <el-option v-for="(item, index) in comboOption.attendance" :key="item.comboValue"
                                       :value="item.comboValue"
                                       :label="item.comboName"/>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="情况说明">
                        <el-input type="textarea" :rows="5" maxlength="500"
                                  show-word-limit v-model="modSituationForm.situation"/>
                    </el-form-item>
                </el-form>
                <div style="width:100%; text-align:center; margin-top:20px;">
                    <el-button type="primary" @click="saveModSituation">保 存</el-button>
                    <el-button @click="modSituationDialogVisible = false">取 消</el-button>
                </div>
                <br/>
            </el-dialog>


        </el-tabs>
    </div>
</template>

<script>
import {confirmMsg, showNotify} from "../../utils/message";
import {globalConfig} from "../../../static/config";
import previewer from 'views/file/previewer.vue';

export default {
    components: {
        previewer,
    },
    props: ['userCode', 'userType', 'id', 'recType', 'dialogWidth', 'type'],
    showUploadBtn: {
        type: Boolean,
        default: true,
    },
    data() {
        return {
            form: {
                id: '',
                classCode: '',
                className: '',
                date: '',
                site: '',
                theme: '',
                situation: '',
                userCode: ''
            },
            activeName: 'first',
            comboOption: {
                class: [],
                attendance: [
                    {'comboValue': '0', 'comboName': '缺勤'},
                    {'comboValue': '1', 'comboName': '出勤'}
                ]
            },
            tableData: [],
            rules: {
                classCode: [{required: true, message: "请选择班级", trigger: ["blur", "change"],}],
                date: [{required: true, message: "请选择返校时间", trigger: ["blur", "change"],}],
                site: [{required: true, message: "请填写返校地点", trigger: ["blur", "change"],}],
                theme: [{required: true, message: "请填写返校主题", trigger: ["blur", "change"],}],
                situation: [{required: true, message: "请填写返校情况", trigger: ["blur", "change"],}],
            },
            queryStuForm: {
                id: '',
                stuCode: ''
            },
            selection: [],
            fileImgList: [],
            photoTitle: '',
            dialogImageUrl: '',
            photoDialogVisible: '',
            stuAttendanceInfo: {
                attendance: '',
                situation: ''
            },
            modSituationDialogVisible: false,
            modSituationForm: {
                id: '',
                stuCode: '',
                stuName: '',
                attendance: '',
                situation: ''
            }
        }
    },
    mounted() {
        if (this.dialogWidth !== '90%') {
            this.dialogWidth = '60%'
        }

        this.form.userCode = this.userCode
        if (this.recType === 'add') {
            this.loadClass()
        } else {
            this.form.id = this.id
            this.queryStuForm.id = this.id
            this.loadHomecomingInfo()
            this.loadStuAttendance()
            this.loadPhoto()
        }

        if (this.userType === 'stu') {
            this.loadStuAttendanceInfo()
        }
    },
    methods: {
        changeSituation(rowData) {
            this.$api.postPracticeManage.homecomingRecord.changeSituation({
                data: rowData,
            })
                .then((res) => {
                    if (res.data.data === 'success') {
                        // showNotify('成功', '保存成功', 'success', 1500);
                    } else {
                        showNotify('失败', '保存失败', 'error', 3000);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        changeAttendanceState(rowData) {
            this.$api.postPracticeManage.homecomingRecord.changeAttendanceState({
                data: rowData,
            })
                .then((res) => {
                    if (res.data.data === 'success') {
                        // showNotify('成功', '保存成功', 'success', 1500);
                    } else {
                        showNotify('失败', '保存失败', 'error', 3000);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        saveModSituation() {
            this.$api.postPracticeManage.homecomingRecord.saveModSituation({
                data: this.modSituationForm,
            })
                .then((res) => {
                    if (res.data.data === 'success') {
                        showNotify('成功', '保存成功', 'success', 1500);
                        this.loadStuAttendance()
                        this.modSituationDialogVisible = false
                    } else {
                        showNotify('失败', '保存失败', 'error', 3000);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        modSituation(rowData) {
            this.modSituationForm.id = rowData.id;
            this.modSituationForm.stuCode = rowData.stuCode;
            this.modSituationForm.stuName = rowData.stuName;
            this.modSituationForm.attendance = rowData.attendance;
            this.modSituationForm.situation = rowData.situation;
            this.modSituationDialogVisible = true
        },
        loadStuAttendanceInfo() {
            let form = {
                'id': this.id,
                'stuCode': this.userCode
            }
            this.$api.postPracticeManage.homecomingRecord.loadStuAttendanceInfo({
                data: form,
            })
                .then((res) => {
                    this.stuAttendanceInfo.attendance = res.data.data.attendance
                    this.stuAttendanceInfo.situation = res.data.data.situation
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        loadPhoto() {
            this.$api.postPracticeManage.homecomingRecord.loadPhoto({
                data: this.id
            }).then((res) => {
                this.fileImgList = res.data.data
                this.fileImgList.forEach(item => {
                    item.url = globalConfig.HOST_PROXY_ADMIN + globalConfig.fileApi + item.url
                })
            }).catch((err) => {
                console.log(err);
            });
        },
        uploadPhoto(param) {
            let formData = new FormData();
            formData.append('file', param.file);
            formData.append('id', this.form.id)
            formData.append('userCode', this.userCode);
            this.$api.postPracticeManage.homecomingRecord.uploadPhoto({
                data: formData
            })
                .then((res) => {
                    if (res.data.data.state == 'success') {
                        showNotify('成功', '上传成功', 'success', 1500);
                        res.data.data.photo.url = globalConfig.HOST_PROXY_ADMIN + globalConfig.fileApi + res
                            .data.data.photo.url
                        this.fileImgList.push(res.data.data.photo)
                    } else {
                        showNotify('失败', '上传失败', 'error', 3000);
                        this.loadPhoto()
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        handlePictureCardPreview(file) {
            this.fileInfo.name = file.name;
            this.fileInfo.url = file.url;
            this.fileInfo.type = file.type;
            this.previewerVisible = true;
        },
        handleRemove(file, fileList) {
            this.$api.postPracticeManage.homecomingRecord.removePhoto({
                data: file.id,
            }).then((res) => {
                if (res.data.data == 'success') {
                    showNotify('成功', '删除成功', 'success', 1500);

                    for (let i = 0; i < this.fileImgList.length; i++) {
                        if (this.fileImgList[i].id === file.id) {
                            this.fileImgList.splice(i, 1);
                            break;
                        }
                    }

                } else {
                    showNotify('失败', '删除失败', 'error', 3000);
                    this.loadPhoto()
                }
            }).catch((err) => {
                showNotify('错误', err, 'error', 3000);
            });
        },
        parseAttendance(rowData) {
            let str = ''
            if (rowData.attendance === '1') {
                str = '出勤'
            } else if (rowData.attendance === '0') {
                str = '缺勤'
            }
            return str;
        },
        // changeAttendanceState(type) {
        //     if (this.selection.length === 0) {
        //         this.alertMsg('请至少选择一名学生');
        //         return;
        //     }
        //
        //     let formData = new FormData()
        //     let arr = []
        //     this.selection.forEach(item => {
        //         arr.push(item.stuCode)
        //     })
        //     formData.append('id', this.id)
        //     formData.append('stu', arr)
        //     formData.append('state', type)
        //     this.$api.postPracticeManage.homecomingRecord.changeAttendanceState({
        //         data: formData,
        //     }).then((res) => {
        //         if (res.data.data === 'success') {
        //             showNotify('成功', '保存成功', 'success', 1500);
        //             this.loadStuAttendance()
        //         } else {
        //             showNotify('失败', '保存失败', 'error', 3000);
        //         }
        //     }).catch((err) => {
        //         showNotify('错误', err, 'error', 3000);
        //     });
        // },
        handleSelection(val) {
            this.selection = val;
        },
        loadStuAttendance() {
            this.$api.postPracticeManage.homecomingRecord.loadStuAttendance({
                data: this.queryStuForm,
            })
                .then((res) => {
                    this.tableData = res.data.data
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        loadHomecomingInfo() {
            this.$api.postPracticeManage.homecomingRecord.loadHomecomingInfo({
                data: this.id,
            })
                .then((res) => {
                    this.form.classCode = res.data.data.classCode
                    this.form.className = res.data.data.className
                    this.form.date = res.data.data.date
                    this.form.site = res.data.data.site
                    this.form.theme = res.data.data.theme
                    this.form.situation = res.data.data.situation
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        saveRec() {
            this.$refs['form'].validate((valid) => {
                if (valid) {
                    this.$api.postPracticeManage.homecomingRecord.save({
                        data: this.form,
                    }).then((res) => {
                        if (res.data.data == 'success') {
                            showNotify('成功', '保存成功', 'success', 1500);
                            this.callback()
                        } else {
                            showNotify('失败', '保存失败', 'error', 3000);
                        }
                    }).catch((err) => {
                        showNotify('错误', err, 'error', 3000);
                    });
                } else {
                    return false;
                }
            })
        },
        loadClass() {
            this.$api.postPracticeManage.homecomingRecord.loadClass({
                data: this.userCode,
            })
                .then((res) => {
                    this.comboOption.class = res.data.data
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        callback() {
            this.$emit("callback");
        },
        indexMethod(index) {
            return index + 1;
        },
        handleReset() {
            this.queryStuForm.stuCode = '';
            this.loadStuAttendance();
        },
        alertMsg(str) {
            this.$message({
                message: str,
                type: 'warning'
            });
        },
        parseSituation(rowData) {
            let str = rowData.situation
            if (str.length > 15) {
                return str.slice(0, 14) + '...'
            }
            return str;
        },
    }
}
</script>

<style scoped lang="scss">
.hidden-Btn {
    /deep/ .el-upload {
        display: none;
    }
}
</style>



// WEBPACK FOOTER //
// homecomingRecord.vue?11e2bf58